module.exports = __webpack_public_path__ + "img/best_crop_2cbed0f47a9f57cc5ca2_SpaceX_launch.7bd16366.jpg";